<template>
  <tr>
    <td style="width: 98%; position: relative">
      <input
        @input="searchArticleField"
        class="mid-2"
        type="text"
        v-model="row.article_number"
        :disabled="cancelled || booked"
        style="width: 95%; margin: auto; display: block"
      />
      <div
        v-if="showArticle"
        style="
          z-index: 9999;
          width: 350px;
          position: absolute;
          left: 2.5%;
          top: 100%;
        "
        class="bg-white rounded shadow-md border p-2 amount-dropdown"
      >
        <ul style="padding-left: 0.3rem !important; list-style-type: none">
          <li
            class="border-bottom p-2 cursor-pointer"
            v-for="item in searchArticle.slice(0, 5)"
            :key="item.article_number"
            @click="chooseArticle(item)"
          >
            <div>
              <strong>{{ item.article_number }}</strong>
            </div>
            <div>{{ item.description }}</div>
          </li>
        </ul>
      </div>
    </td>
    <td colspan="2" class="description">
      <input
        type="text"
        v-model="row.description"
        :disabled="cancelled || booked"
        style="width: 98%"
      />
    </td>
    <td style="width: 98%; position: relative">
      <input
        class="mid col-form"
        type="number"
        min="1"
        v-model="row.delivered_quantity"
        v-on:change="computeTotal"
        :disabled="cancelled || booked"
        style="width: 95%; margin: auto; display: block"
      />
    </td>
    <td style="width: 98%; position: relative">
      <select
        class="mid input-select col-form"
        v-model="row.unit"
        :disabled="cancelled || booked"
        style="width: 95%; margin: auto; display: block"
      >
        <option value=""></option>
        <option :value="item.code" v-for="item in units" :key="item.id">
          {{ GET_LOCALE === "se" ? item.code : item.code_english }}
        </option>
      </select>
    </td>
    <td style="width: 98%; position: relative">
      <input
        class="small col-form"
        type="text"
        v-if="vat_included"
        v-model="row.price"
        :disabled="cancelled || booked"
        v-on:change="computeTotal"
        style="width: 95%; margin: auto; display: block"
      />
      <input
        class="small col-form"
        type="text"
        v-else
        v-model="row.price_excluding_vat"
        :disabled="cancelled || booked"
        v-on:change="computeTotal"
        style="width: 95%; margin: auto; display: block"
      />
    </td>
    <td style="width: 98%; position: relative">
      <input
        class="mid col-form"
        type="text"
        v-model="row.discount"
        :disabled="cancelled || booked"
        style="width: 95%; margin: auto; display: block"
      />
    </td>
    <td style="width: 98%; position: relative">
      <input
        class="small col-form"
        v-if="vat_included"
        type="text"
        v-model="row.total"
        disabled
        style="width: 95%; margin: auto; display: block"
      />
      <input
        class="small col-form"
        v-else
        type="text"
        v-model="row.total_excluding_vat"
        style="width: 95%; margin: auto; display: block"
      />
    </td>
    <td style="width: 98%; position: relative">
      <select
        class="mid input-select col-form"
        v-model="row.cost_center"
        style="width: 64px"
        :disabled="cancelled || booked"
      >
        <option value=""></option>
        <option :value="item.code" v-for="item in costCenter" :key="item.id">
          {{ item.description }}
        </option>
      </select>
    </td>
    <td>
      <select
        class="big input-select col-form"
        v-model="row.project"
        style="width: 64px"
        :disabled="cancelled || booked"
      >
        <option value=""></option>
        <option
          :value="item.project_number"
          v-for="item in project"
          :key="item.id"
        >
          {{ item.description }}
        </option>
      </select>
    </td>
    <td>
      <input
        class="mid col-form"
        type="number"
        min="1"
        v-model="row.vat"
        v-on:change="computeTotal('vat')"
        :disabled="cancelled || booked"
      />
    </td>
    <td>
      <input
        @input="searchAccountField"
        class="mid col-form"
        type="text"
        v-model="row.account_number"
        :disabled="cancelled || booked"
        style="width: 95%; margin: auto; display: block"
      />
      <div
        v-if="showAccount"
        style="
          z-index: 9999;
          width: 350px;
          position: absolute;
          left: 2.5%;
          top: 100%;
        "
        class="bg-white rounded shadow-md border p-2 amount-dropdown"
      >
        <ul style="padding-left: 0.3rem !important; list-style-type: none">
          <li
            class="border-bottom p-2 cursor-pointer"
            v-for="item in searchAccounts.slice(0, 5)"
            :key="item.number"
            @click="chooseAccount(item)"
          >
            <div>
              <strong>{{ item.number }}</strong>
            </div>
            <div>{{ item.description }}</div>
          </li>
        </ul>
      </div>
    </td>
    <td style="width: 98%; position: relative">
      <!--      #4ade80-->
      <span
        v-if="showContractUpdate === true"
        v-on:click="showContactUpdatePopModal"
        class="cursor-pointer ml-20px mr-10px"
      >
        <svg
          width="24.2"
          height="24.2"
          viewBox="0 0 22 22"
          :fill="fillRecurringColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.6 17.6002C6.6 17.8919 6.71589 18.1717 6.92218 18.378C7.12847 18.5843 7.40826 18.7002 7.7 18.7002H10.56C10.7613 19.094 11.0044 19.4625 11.2827 19.8002H7.7C7.11652 19.8002 6.55694 19.5684 6.14437 19.1558C5.73178 18.7432 5.5 18.1837 5.5 17.6002V4.4002C5.5 3.81672 5.73178 3.25714 6.14437 2.84456C6.55694 2.43198 7.11652 2.2002 7.7 2.2002H14.3C14.8835 2.2002 15.4431 2.43198 15.8556 2.84456C16.2682 3.25714 16.5 3.81672 16.5 4.4002V9.9244C16.1341 9.89142 15.7659 9.89142 15.4 9.9244V4.4002C15.4 4.10846 15.2841 3.82867 15.0778 3.62238C14.8715 3.41609 14.5917 3.3002 14.3 3.3002H7.7C7.40826 3.3002 7.12847 3.41609 6.92218 3.62238C6.71589 3.82867 6.6 4.10846 6.6 4.4002V17.6002ZM10.45 13.4268C10.7257 12.8279 11.0972 12.278 11.55 11.7988V7.9268L12.8106 9.1885C12.9139 9.29177 13.0539 9.34979 13.2 9.34979C13.3461 9.34979 13.4861 9.29177 13.5894 9.1885C13.6927 9.08522 13.7507 8.94515 13.7507 8.7991C13.7507 8.65304 13.6927 8.51297 13.5894 8.4097L11.3894 6.2097C11.3383 6.15848 11.2776 6.11784 11.2108 6.09011C11.144 6.06238 11.0723 6.04811 11 6.04811C10.9277 6.04811 10.856 6.06238 10.7892 6.09011C10.7224 6.11784 10.6617 6.15848 10.6106 6.2097L8.4106 8.4097C8.35946 8.46083 8.3189 8.52154 8.29122 8.58835C8.26355 8.65517 8.24931 8.72678 8.24931 8.7991C8.24931 8.87141 8.26355 8.94302 8.29122 9.00984C8.3189 9.07665 8.35946 9.13736 8.4106 9.1885C8.46174 9.23963 8.52244 9.2802 8.58926 9.30787C8.65607 9.33555 8.72768 9.34979 8.8 9.34979C8.87232 9.34979 8.94393 9.33555 9.01074 9.30787C9.07756 9.2802 9.13826 9.23963 9.1894 9.1885L10.45 7.9279V13.4268ZM20.9 15.9502C20.9 17.263 20.3785 18.5221 19.4502 19.4504C18.5219 20.3787 17.2628 20.9002 15.95 20.9002C14.6372 20.9002 13.3781 20.3787 12.4498 19.4504C11.5215 18.5221 11 17.263 11 15.9502C11 14.6374 11.5215 13.3783 12.4498 12.45C13.3781 11.5217 14.6372 11.0002 15.95 11.0002C17.2628 11.0002 18.5219 11.5217 19.4502 12.45C20.3785 13.3783 20.9 14.6374 20.9 15.9502ZM18.5394 13.9108C18.4883 13.8596 18.4276 13.8189 18.3608 13.7912C18.294 13.7635 18.2223 13.7492 18.15 13.7492C18.0777 13.7492 18.006 13.7635 17.9392 13.7912C17.8724 13.8189 17.8117 13.8596 17.7606 13.9108L14.85 16.8225L14.1394 16.1108C14.0361 16.0075 13.8961 15.9495 13.75 15.9495C13.6039 15.9495 13.4639 16.0075 13.3606 16.1108C13.2573 16.2141 13.1993 16.3541 13.1993 16.5002C13.1993 16.6462 13.2573 16.7863 13.3606 16.8896L14.4606 17.9896C14.5117 18.0408 14.5724 18.0815 14.6392 18.1092C14.706 18.1369 14.7777 18.1512 14.85 18.1512C14.9223 18.1512 14.994 18.1369 15.0608 18.1092C15.1276 18.0815 15.1883 18.0408 15.2394 17.9896L18.5394 14.6896C18.5906 14.6385 18.6313 14.5778 18.659 14.511C18.6867 14.4442 18.701 14.3725 18.701 14.3002C18.701 14.2279 18.6867 14.1562 18.659 14.0894C18.6313 14.0226 18.5906 13.9619 18.5394 13.9108Z"
            :fill="fillRecurringColor"
          />
        </svg>
      </span>
      <span
        @click="openScheduleInvoiceRowModal"
        v-if="showSchedule === true"
        class="cursor-pointer"
      >
        <svg style="width: 26.4px; height: 26.4px" viewBox="0 0 24 24">
          <path
            :fill="fillColor"
            d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"
          ></path>
        </svg>
      </span>
    </td>
    <td style="width: 98%">
      <span @click="removeRow(row)" v-if="!cancelled && !booked && !fully_paid">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          style="color: red"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
      <span v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          style="color: grey"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </td>
  </tr>
  <ModalBoxVue
    v-if="schedulingModal"
    @handleClose="schedulingModal = false"
    :close="!true"
  >
    <div class="p-4">
      <h5>{{ $t("scheduleRowChange") }}</h5>
      <hr />
      <div class="container p-3 confirmModal">
        <!--        <div class="mb-3" v-if="getMode !== 'create'">-->
        <!--          <p class="mb-2">{{ $t("pickScheduleAction") }}</p>-->
        <!--          {{ data.scheduled_invoice_row_change }}-->
        <!--          <select-->
        <!--              v-model="actionKey"-->
        <!--              style="width: 100%"-->
        <!--              v-on:change="onChangeActionKey"-->
        <!--              class="inputFields"-->
        <!--          >-->
        <!--            <option value="create">{{ $t("createNewSchedule") }}</option>-->
        <!--            <option :value="schedule.id" v-for="(schedule, i) in data.scheduled_invoice_row_change" :key="i">-->
        <!--              <span v-if="GET_LOCALE === 'se'">Uppdatera instans -{{-->
        <!--                  schedule.swe_change_type-->
        <!--                }} med {{ schedule.new_value }}</span>-->
        <!--              <span v-else>Update instance - {{-->
        <!--                  schedule.change_type.replace('_', ' ').toUpperCase()-->
        <!--                }} with {{ schedule.new_value }}</span>-->
        <!--            </option>-->
        <!--          </select>-->
        <!--        </div>-->
        <div class="mb-3">
          <p class="mb-2">{{ $t("dateOfAction") }}</p>
          <Datepicker
            class="form-control"
            v-model="scheduling.date_of_action"
            format="yyyy-MM-dd"
            style="width: 100% !important"
            :enableTimePicker="false"
            :minDate="today"
          />
        </div>
        <div class="mb-3">
          <label class="mb-1 d-flex">
            <div>
              <span class="tooltip-custom position-relative tooltip-position">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                    fill="#5A58BA"
                  />
                </svg>
                <span class="tooltiptext shadow-tooltip" style="">{{
                  getHelpText("invoice_row_update_type")
                }}</span>
              </span>
            </div>
            <div>
              <span> {{ $t("changeType") }}</span>
            </div>
          </label>
          <select
            v-model="scheduling.change_type"
            style="width: 100%"
            class="inputFields"
          >
            <option value="increase_discount">
              {{ $t("increaseDiscount") }}
            </option>
            <option value="decrease_discount">
              {{ $t("decreaseDiscount") }}
            </option>
            <option value="remove_discount">{{ $t("removeDiscount") }}</option>
            <option value="increase_quantity">
              {{ $t("increaseDeliveredQuantity") }}
            </option>
            <option value="decrease_quantity">
              {{ $t("decreaseDeliveredQuantity") }}
            </option>
            <option value="increase_price">{{ $t("increasePrice") }}</option>
            <option value="decrease_price">{{ $t("decreasePrice") }}</option>
            <option value="change_article">{{ $t("changeArticle") }}</option>
            <option value="remove_row">{{ $t("removeRow") }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="mb-1 d-flex">
            <div>
              <span class="tooltip-custom position-relative tooltip-position">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                    fill="#5A58BA"
                  />
                </svg>
                <span class="tooltiptext shadow-tooltip" style="">{{
                  getHelpText("invoice_row_update_new_value")
                }}</span>
              </span>
            </div>
            <div>
              <span> {{ $t("newValue") }}</span>
            </div>
          </label>
          <input
            :disabled="newValueField"
            class="inputFields"
            v-model="newValue"
            style="width: 100%"
            :type="
              scheduling.change_type !== 'change_article' ? 'number' : 'text'
            "
            min="0"
          />
        </div>
        <div class="mb-3">
          <label class="mb-1 d-flex">
            <div>
              <span class="tooltip-custom position-relative tooltip-position">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                    fill="#5A58BA"
                  />
                </svg>
                <span class="tooltiptext shadow-tooltip" style="">{{
                  getHelpText("invoice_row_update_change_current_value_with")
                }}</span>
              </span>
            </div>
            <div>
              <span> {{ $t("changeCurrentValue") }}</span>
            </div>
          </label>
          <input
            :disabled="changeValueField"
            class="inputFields"
            v-model="changeValue"
            id="search"
            style="width: 100%"
            :type="
              scheduling.change_type !== 'change_article' ? 'number' : 'text'
            "
            min="0"
          />
        </div>
        <div class="confirmModalButtons d-flex">
          <button class="btn btn-outline-dark" @click="schedulingModal = false">
            {{ $t("cancel") }}
          </button>
          <button
            class="btn btn-info--confirm"
            @click="event()"
            :disabled="processingUpdate || processingDelete"
          >
            {{ $t("proceed") }}
          </button>
          <button
            :disabled="processingDelete || processingUpdate"
            class="btn btn-danger"
            @click="deleteScheduleEvent()"
            v-if="
              data.scheduled_invoice_row_change.length > 0 &&
              actionKey !== 'create'
            "
          >
            {{ $t("delete") }}
          </button>
        </div>
      </div>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
    v-if="showContractPopUp"
    @handleClose="showContractPopUp = false"
    :close="!true"
  >
    <recurring-contract-action-component
      :data-obj="row"
      :recurring-contract-list="row.recurring_contract_update"
      :access="this.CURRENT_USER.access"
      :row-index="index"
      :help-text="helpText"
    />
  </ModalBoxVue>
</template>

<script>
import debounce from "lodash.debounce";
import ModalBoxVue from "@/components/ModalBox.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import recurringContractActionComponent from "./recurringContractActionComponent";

const TODAY = moment().format("YYYY-MM-DD");

import { mapGetters } from "vuex";

export default {
  name: "InvoiceRowForm",
  components: {
    ModalBoxVue,
    Datepicker,
    recurringContractActionComponent,
  },
  props: {
    data: {
      type: Object,
    },
    helpText: {
      type: Array,
    },
    index: {
      type: Number,
    },
    booked: {
      type: Boolean,
      default: false,
      required: false,
    },
    cancelled: {
      type: Boolean,
      default: false,
      required: false,
    },
    vat_included: {
      type: Boolean,
      default: false,
      required: false,
    },

    fully_paid: {
      type: Boolean,
      default: false,
      required: false,
    },
    showSchedule: {
      type: Boolean,
      default: false,
      required: false,
    },
    showContractUpdate: {
      type: Boolean,
      default: false,
      required: false,
    },
    rowIndex: {
      type: Number,
      required: false,
    },
    costCenter: {
      type: Array,
      default: () => [],
      required: false,
    },
    project: {
      type: Array,
      default: () => [],
      required: false,
    },
    units: {
      type: Array,
      default: () => [],
      required: false,
    },
    deliveryTerm: {
      type: Array,
      default: () => [],
      required: false,
    },
    pricelist: {
      type: Array,
      default: () => [],
      required: false,
    },
    paymentTerm: {
      type: Array,
      default: () => [],
      required: false,
    },
    deliveryWay: {
      type: Array,
      default: () => [],
      required: false,
    },
    currency: {
      type: Array,
      default: () => [],
      required: false,
    },
    accounts: {
      type: Array,
      default: () => [],
      required: false,
    },
    printOutTemplate: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  data: function () {
    return {
      row: {},
      searchArticle: [],
      searchAccounts: [], // Local copy for search results
      showAccount: false,
      showArticle: false,
      processingDelete: false,
      processingUpdate: false,
      itemIndex: null,
      schedulingModal: false,
      showContractPopUp: false,
      newValueField: false,
      newValue: "",
      mode: "",
      changeValueField: false,
      changeValue: "",
      actionKey: "create",
      contractUpdateActionKey: "create",
      fillColor: "#5855D6",
      fillRecurringColor: "#5855D6",
      scheduling: {
        row_id: "",
        contract_number: "",
        date_of_action: "",
        change_type: "",
        new_value: "",
      },
      contractUpdate: {
        final_value: 0,
        update_with_value: 0,
        contract_number: this.$route.params.num,
        row_id: this.data.row_id,
        update_type: "",
        update_number_of_times: false,
        update_until_specific_value: true,
      },
      contractUpdateType: "update_until_specific_value",
    };
  },
  methods: {
    openScheduleInvoiceRowModal: function () {
      this.schedulingModal = true;
      this.itemIndex = this.index;
      if (this.row.scheduled_invoice_row_change.length > 0) {
        let unhandled = this.row.scheduled_invoice_row_change.filter(
          (item) => item.handled === false
        );
        if (unhandled.length > 0) {
          this.actionKey = unhandled[0].id;
        } else {
          this.actionKey = "create";
        }
      } else {
        this.actionKey = "create";
      }
      this.onChangeActionKey();
    },
    getHelpText: function (field) {
      if (!this.helpText || this.helpText.length === 0) {
        return "";
      }
      let text = this.helpText.filter((item) => item.field === field);
      if (text.length > 0) {
        if (this.GET_LOCALE === "se") {
          return text[0].swedish_text;
        } else {
          return text[0].english_text;
        }
      }
    },
    showContactUpdatePopModal: function () {
      this.showContractPopUp = true;
    },
    deleteContractUpdate: function () {},
    onChangeActionKey: function () {
      if (this.actionKey === "create") {
        this.scheduling = {
          row_id: "",
          contract_number: "",
          date_of_action: "",
          change_type: "",
          new_value: "",
        };
        this.newValue = "";
        this.changeValue = "";
      } else {
        let schedule = this.data.scheduled_invoice_row_change.filter(
          (item) => item.id === this.actionKey
        );
        if (schedule.length > 0) {
          Object.keys(this.scheduling).map((key) => {
            this.scheduling[key] = schedule[0][key];
          });
          if (schedule[0].new_value) {
            this.newValue = schedule[0].new_value;
          }
          if (schedule[0].change_with_value) {
            this.changeValue = schedule[0].change_with_value;
          }
        }
      }
    },
    onChangeRecurringActionKey: function () {
      if (this.contractUpdateActionKey === "create") {
        this.contractUpdate = {
          final_value: 0,
          update_with_value: 0,
          contract_number: this.$route.params.num,
          row_id: this.data.row_id,
          update_type: "",
          update_number_of_times: false,
          update_until_specific_value: true,
        };
      } else {
        let schedule = this.data.recurring_contract_update.filter(
          (item) => item.id === this.contractUpdateActionKey
        );
        if (schedule.length > 0) {
          Object.keys(this.contractUpdate).map((key) => {
            this.contractUpdate[key] = schedule[0][key];
          });
        }
      }
    },
    searchArticleField: debounce(function (event) {
      if (event.target.value !== "") {
        this.filterArticleSearch(event.target.value);
      } else {
        this.showArticle = false;
      }
    }, 500),
    searchAccountField: debounce(function (event) {
      if (event.target.value !== "") {
        this.filterAccountSearch(event.target.value);
      } else {
        this.showArticle = false;
      }
    }, 500),
    filterArticleSearch(data) {
      const payload = {
        URL:
          this.$services.endpoints.ARTICLE_ENDPOINT +
          `?search=${data}&customize=no&active=1`,
      };
      this.$store
        .dispatch("clients/getCustomRequest", payload)
        .then((res) => {
          if (res.data.data.length > 0) {
            this.showArticle = true;
            this.searchArticle = res.data.data.filter(
              (item) => item.active === true
            );
          }
        })
        .catch((err) => {});
    },
    getDiscountedTotal(total, discount, discountType) {
      if (discount) {
        if (discountType === "AMOUNT") {
          total = total - discount;
        } else {
          total =
            total *
            (1 -
              parseFloat(
                this.$services.helpers.removePercentage(discount) / 100
              ));
        }
      }
      return parseFloat(total.toFixed(2));
    },
    filterAccountSearch(data) {
      const URL =
        this.$services.endpoints.REGISTER_ENDPOINT + `accounts?search=${data}`;
      this.$store
        .dispatch("clients/getCustomRequest", { URL })
        .then((res) => {
          this.showAccount = true;
          this.searchAccounts = res.data.results;
        })
        .catch((err) => {});
    },

    chooseArticle(item) {
      if (!item.active) {
        this.$toast.warning(
          "This article is not active. Please select another article."
        );
        return;
      }
      this.row.article_number = item.article_number;
      this.row.description = item.description;
      this.row.price = item.sales_price == null ? 0 : item.sales_price;
      if (item.sales_price !== null && this.row.delivered_quantity !== null) {
        let total = this.row.price * this.row.delivered_quantity;
        if (!isNaN(total)) {
          this.row.total = total;
        } else {
          this.row.total = 0;
        }
      }
      this.row.vat = item.vat;
      this.row.account_number = item.sales_account;
      this.row.cost_center = item.cost_center;
      this.row.project = item.project;
      this.row.unit = item.unit;

      this.showArticle = false;
      this.$emit("onRowChange", { data: this.row, index: this.index });
    },
    computeTotal: function (changedData) {
      // this.row.total = this.row.delivered_quantity * this.row.price
      if (
        this.row.delivered_quantity !== "" &&
        this.row.delivered_quantity !== null &&
        this.row.price_excluding_vat !== "" &&
        this.row.price_excluding_vat !== null &&
        this.row.price !== "" &&
        this.row.price !== null
      ) {
        if (this.vat_included) {
          if (changedData && changedData === "vat") {
            if (this.row.vat) {
              this.row.price = (
                this.row.price_excluding_vat *
                (1 + this.row.vat / 100)
              ).toFixed(2);
            } else {
              this.row.price = this.row.price_excluding_vat.toFixed(2);
            }
          }

          this.row.total =
            parseInt(this.row.delivered_quantity) * parseFloat(this.row.price);
          this.row.total = this.getDiscountedTotal(
            this.row.total,
            this.row.discount,
            this.row.discount_type
          );
          if (this.row.vat) {
            this.row.total_excluding_vat = (
              this.row.total /
              (1 + this.row.vat / 100)
            ).toFixed(2);
          } else {
            this.row.total_excluding_vat = this.row.total.toFixed(2);
          }

          if (this.row.vat) {
            this.row.price_excluding_vat = (
              parseFloat(this.row.price) /
              parseFloat(1 + parseFloat(this.row.vat) / 100)
            ).toFixed(2);
          } else {
            this.row.price_excluding_vat = parseFloat(this.row.price).toFixed(
              2
            );
          }

          this.row.price = parseFloat(this.row.price).toFixed(2);

          this.row.price_per_unit = this.row.price_excluding_vat;
        } else {
          this.row.total_excluding_vat =
            parseFloat(this.row.delivered_quantity).toFixed(2) *
            parseFloat(this.row.price_excluding_vat);
          this.row.total_excluding_vat = this.getDiscountedTotal(
            this.row.total_excluding_vat,
            this.row.discount,
            this.row.discount_type
          );
          this.row.price_per_unit = this.row.price_excluding_vat;
          this.row.price =
            parseFloat(this.row.price_excluding_vat) +
            parseFloat(this.row.price_excluding_vat);
          if (this.row.vat) {
            this.row.price = this.row.price * parseFloat(this.row.vat / 100);
          }
          this.row.price = parseFloat(this.row.price.toFixed(2));

          let vat = this.row.vat
            ? (
                this.row.total_excluding_vat * parseFloat(this.row.vat / 100)
              ).toFixed(2)
            : "0.00";

          this.row.total = parseFloat(
            this.row.total_excluding_vat + vat
          ).toFixed(2);
        }
        this.$emit("onRowChange", { data: this.row, index: this.row_index });
      }
    },
    chooseAccount(item) {
      if (!item.active) {
        this.$toast.warning(
          "This account is not active. Please select another account."
        );
        return;
      }
      this.row.account_number = item.number;
      this.showAccount = false;
      this.$emit("onRowChange", { data: this.row, index: this.row_index });
    },
    updateParentRow: function () {
      this.$emit("onRowChange", { data: this.row, index: this.row_index });
    },
    removeRow: function (item) {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.$emit("removeRow", item);
      // this.$emit('removeRow', this.data)
    },
    event: function () {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.scheduling["contract_number"] = this.$route.params.num;
      this.scheduling["row_id"] = this.data.row_id;
      this.processingUpdate = true;
      if (this.actionKey === "create") {
        this.$store
          .dispatch("clients/addScheduleEvent", this.scheduling)
          .then((res) => {
            let dt = res.data.data;
            dt["handled"] = false;
            this.row["scheduled_invoice_row_change"].push(dt);
            this.getColor();
            this.schedulingModal = false;
            this.$services.helpers.notification(
              res.data[this.locale_message],
              "success",
              this
            );
          })
          .catch((err) => {
            this.schedulingModal = false;
            this.$services.helpers.notification(
              err.response.data[this.locale_message],
              "error",
              this
            );
          });
      } else {
        this.$store
          .dispatch("clients/updateScheduleEvent", {
            id: this.actionKey,
            data: this.scheduling,
          })
          .then((res) => {
            this.schedulingModal = false;
            let rowId = this.row.scheduled_invoice_row_change.filter(
              (item) => item.id === this.actionKey
            );
            if (rowId > -1) {
              this.row.scheduled_invoice_row_change[rowId] = res.data.data;
            }
            this.getColor();
            this.$services.helpers.notification(
              res.data[this.locale_message],
              "success",
              this
            );
          })
          .catch((err) => {
            this.schedulingModal = false;
            this.$services.helpers.notification(
              err.response.data[this.locale_message],
              "error",
              this
            );
          });
      }
      this.processingUpdate = false;
    },
    getColor: function () {
      try {
        if (this.row) {
          // #4ade80
          if ("scheduled_invoice_row_change" in this.row) {
            if (this.row.scheduled_invoice_row_change.length > 0) {
              let handled = this.row.scheduled_invoice_row_change.filter(
                (item) => item.handled === false
              );
              if (handled.length > 0) {
                this.fillColor = "#4ade80";
                return false;
              }
            }
          }
        }
        this.fillColor = "#5855D6";
      } catch (e) {
        // left blank
      }
    },
    getRecurringColor: function () {
      try {
        if (this.row) {
          if ("recurring_contract_update" in this.row) {
            if (this.row.recurring_contract_update.length > 0) {
              let handled = this.row.recurring_contract_update.filter(
                (item) => item.status === "ongoing"
              );
              if (handled.length > 0) {
                this.fillRecurringColor = "#4ade80";
                return false;
              }
            }
          }
        }
        this.fillRecurringColor = "#5855D6";
      } catch (e) {
        // left blank
      }
    },
    createOrUpdateRecurringContract: function () {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.contractUpdate["contract_number"] = this.$route.params.num;
      this.contractUpdate["row_id"] = this.data.row_id;
      if (this.contractUpdateType === "update_until_specific_value") {
        this.contractUpdate["update_until_specific_value"] = true;
        this.contractUpdate["update_number_of_times"] = false;
      } else {
        this.contractUpdate["update_until_specific_value"] = false;
        this.contractUpdate["update_number_of_times"] = true;
      }
      if (this.contractUpdateActionKey === "create") {
        this.$store
          .dispatch("clients/createRecurringSchedule", {
            data: this.contractUpdate,
          })
          .then((res) => {
            let dt = res.data.data;
            dt["status"] = "ongoing";
            this.row["recurring_contract_update"].push(dt);
            this.getRecurringColor();
            this.showContractPopUp = false;
            this.$services.helpers.notification(
              res.data.message,
              "success",
              this
            );
          })
          .catch((err) => {
            this.schedulingModal = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      } else {
        this.$store
          .dispatch("clients/updateRecurringSchedule", {
            data: this.contractUpdate,
            id: this.contractUpdateActionKey,
          })
          .then((res) => {
            this.getRecurringColor();
            this.showContractPopUp = false;
            this.$services.helpers.notification(
              res.data.message,
              "success",
              this
            );
          })
          .catch((err) => {
            this.schedulingModal = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      }
    },
    deleteScheduleEvent: function () {
      this.processingDelete = true;
      this.$store
        .dispatch("clients/deleteScheduleEvent", { id: this.actionKey })
        .then((res) => {
          this.processingDelete = false;
          this.$services.helpers.notification(
            this.$t("deletedSuccessfully"),
            "success",
            this
          );
          let findIndex = this.row["scheduled_invoice_row_change"].findIndex(
            (item) => String(item.id) === String(this.actionKey)
          );
          if (findIndex > -1) {
            this.row["scheduled_invoice_row_change"].splice(findIndex, 1);
          }
          this.getColor();
          this.schedulingModal = false;
        })
        .catch((err) => {
          this.processingDelete = false;
          this.$services.helpers.notification(
            err.response.data[this.locale_message],
            "error",
            this
          );
        });
    },
  },

  mounted() {
    this.row = this.data;
    this.getColor();
    this.getRecurringColor();
    window.Bus.on("close-recurring-contract-popup", (e) => {
      this.showContractPopUp = false;
    });
    window.Bus.on("update-recurring-contract-update", (e) => {
      this.showContractPopUp = false;
      if (String(e.index)) {
        if (String(e.index) === String(this.index) && e.action === "add") {
          this.row["recurring_contract_update"].push(e.data);
          this.getRecurringColor();
          this.showContractPopUp = false;
        } else if (
          String(e.index) === String(this.index) &&
          e.action === "update"
        ) {
          let rowIndex = this.row["recurring_contract_update"].findIndex(
            (item) => String(item.row_id) === String(e.data.row_id)
          );
          if (rowIndex > -1) {
            this.row["recurring_contract_update"][rowIndex]["final_value"] =
              e.data.final_value;
            this.row["recurring_contract_update"][rowIndex][
              "update_with_value"
            ] = e.data.update_with_value;
          }
          this.getRecurringColor();
          this.showContractPopUp = false;
        }
      }
    });
    window.Bus.on("remove-recurring-contract", (e) => {
      this.showContractPopUp = false;
      if (String(e.rowIndex)) {
        if (String(e.rowIndex) === String(this.index)) {
          let row = this.row["recurring_contract_update"];
          let findIndex = row.findIndex(
            (item) => String(item.id) === String(e.key)
          );
          if (findIndex > -1) {
            row.splice(findIndex, 1);
          }
          this.getRecurringColor();
        }
      }
    });

    if ("scheduled_invoice_row_change" in this.row) {
      if (this.row.scheduled_invoice_row_change.length > 0) {
        this.row.scheduled_invoice_row_change.sort(function (a, b) {
          return b - a;
        });
        this.actionKey = this.row.scheduled_invoice_row_change[0].id;
        this.onChangeActionKey();
      }
    }
  },
  created() {
    this.scheduling.row_id =
      this.SINGLE_CONTRACT?.invoice_rows?.[this.index]?.row_id || "";
    this.scheduling.contract_number =
      this.SINGLE_CONTRACT?.document_number || "";
  },
  watch: {
    "scheduling.date_of_action": function (newVal, oldVal) {
      if (newVal instanceof Date) {
        let value = `${newVal.getFullYear()}-${
          newVal.getMonth() + 1
        }-${newVal.getDate()}`;
        this.scheduling.date_of_action = value;
      }
    },
    changeValue: function (newVal, oldVal) {
      if (String(newVal).length > 0) {
        this.newValueField = true;
        delete this.scheduling.new_value;
        this.scheduling.change_with_value = newVal;
      } else {
        this.newValueField = false;
      }
    },
    newValue: function (newVal, oldVal) {
      let val = String(newVal);
      if (val.length > 0) {
        this.changeValueField = true;
        delete this.scheduling.change_with_value;
        this.scheduling.new_value = newVal;
      } else {
        this.changeValueField = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      CURRENT_USER: "clients/GET_CURRENT_USER",
      GET_LOCALE: "locale/GET_LOCALE",
      SINGLE_CONTRACT: "clients/GET_SINGLE_CONTRACT",
    }),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    getMode() {
      if (this.data && this.data.scheduled_invoice_row_change.length > 0) {
        return "create_and_update";
      } else {
        return "create";
      }
    },
    hasRecurringUpdate() {
      if (this.data && this.data.recurring_contract_update.length > 0) {
        return "create_and_update";
      } else {
        return "create";
      }
    },
    locale_message() {
      return this.GET_LOCALE === "se" ? "message" : "eng_message";
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-none {
  cursor: none !important;
}

.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content .headers {
  margin: 30px 0 10px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.content .headers h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content .headers h1 ~ h6 {
  font-size: 16px;
  line-height: 24px;
  color: #333269;
  font-weight: 400;
}

.content .contract-duration {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  background: #fffdfd;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 5px;
  padding: 20px 30px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 20px 0 35px;
}

.content .contract-duration h2 {
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: #333269;
  margin: 0;
}

.content .contract-duration .duration {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}

.content .contract-duration .duration p {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #333269;
  margin: 0;
}

.content .contract-duration .duration p:first-of-type {
  margin-right: 20px;
}

.content .box {
  background: #fffdfd;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 5px;
  margin-top: 20px;
}

.content .box.contract-details img {
  width: 55px;
  height: 55px;
  margin-left: auto;
  cursor: pointer;
}

.content .box h3 {
  background: #5855d6;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #fffdfd;
  padding: 30px;
  border-radius: 5px 5px 0px 0px;
  margin: 0;
}

.content .box form {
  padding: 30px;
}

@media (min-width: 992px) {
  .content .box form > div:not(:last-of-type) {
    margin-bottom: 30px;
  }
}

.content .box form > div .desc:last-of-type {
  margin-right: 0;
}

.content .box form .desc {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin: 7px;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
}

.content .box form .desc label {
  margin-bottom: 10px;
}

.content .box form .desc input {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  border: none;
  height: 32px;
  width: 150px;
  text-indent: 10px;
  padding-right: 5px;
}

.content .box form .desc input.big {
  width: 192px;
}

.content .box form .desc input:-moz-read-only {
  background: #c8c7cd;
}

.content .box form .desc input:read-only {
  background: #c8c7cd;
}

.content .box form .desc input:focus {
  outline: none;
}

.content .box form .desc input[type="number"] {
  width: 55px;
  -webkit-appearance: textfield;
  appearance: textfield;
  -moz-appearance: textfield;
}

.content .box form .desc input[type="number"]::-webkit-outer-spin-button,
.content .box form .desc input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.content .box form .desc select {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  height: 32px;
  width: 150px;
  border: none;
  text-indent: 5px;
}

.content .box form .desc select.big {
  width: 192px;
}

.content .box form .desc .radio {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background: #333269;
  border-radius: 4px;
  color: #d2d1d7;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
}

.content .box form .desc .radio input {
  display: none;
}

.content .box form .desc .radio input:checked + label {
  background: #f6f8fc;
  color: #000000;
}

.content .box form .desc .radio label {
  margin: 0;
  cursor: pointer;
  padding: 1px 11.5px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  border-radius: 4px;
}

.content .box form .desc .radio label:first-of-type {
  margin-right: 10px;
}

@media (min-width: 992px) {
  .content .box.contract-details form > div:first-of-type {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}

@media (min-width: 992px) {
  .content .box.customer-details .desc {
    margin-right: 5%;
  }
}

.content .box table {
  width: 94%;
  margin: 10px auto;
  background: #fff;
}

.content .box table thead th {
  font-size: 10px;
  line-height: 18px;
  color: #000000;
  background: #f6f8fc;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
}

.content .box table thead th:nth-of-type(1),
.content .box table thead th:nth-of-type(2) {
  text-align: left;
  padding-left: 15px;
}

.content .box table thead th:nth-of-type(2) {
  padding-right: 80px;
}

.content .box table thead th:last-of-type {
  padding-right: 15px;
}

.content .box table tbody tr {
  position: relative;
}

.content .box table tbody tr:after {
  content: "";
  position: absolute;
  width: -webkit-calc(100% - 30px);
  width: calc(100% - 30px);
  height: 1px;
  background-color: #cbd4e1;
  left: 15px;
  bottom: 0;
}

.content .box table tbody tr td {
  vertical-align: middle;
  padding: 10px 15px;
  position: relative;
}

.content .box table tbody tr td input {
  background: #e6e5eb;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  height: 22px;
  border: none;
  display: block;
  padding: 1px 5px;
  margin: 0 auto;
  text-align: center;
}

.content .box table tbody tr td input:focus {
  border: none;
  outline: none;
}

.content .box table tbody tr td input.big {
  max-width: 188px;
}

.content .box table tbody tr td select.mid,
.content .box table tbody tr td input.mid {
  max-width: 64px;
}

.content .box table tbody tr td input.small {
  width: 31px;
}

.content .box table tbody tr td:not(:last-of-type):after {
  content: "";
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #cbd4e1;
  right: 0;
  top: 0;
}

.content .box table tbody tr td:nth-of-type(1) input,
.content .box table tbody tr td:nth-of-type(2) input {
  margin-left: 5px;
  text-align: left;
}

.content .box button {
  background: #5855d6;
  width: 126px;
  height: 38px;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  border: none;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 3%;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .box button:hover {
  background-color: #4947b0;
  color: #fff;
}

.content .box textarea {
  background: #f0eff5;
  border-radius: 5px;
  height: 78px;
  resize: none;
  width: 214px;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  border: none;
  padding: 10px;
}

.content .box textarea:focus {
  border: none;
  outline: none;
}

.content .box.others-details {
  min-height: 320px;
}

.content .box.price {
  padding: 30px 20px;
}

.content .box.price ul {
  margin: 0;
}

.content .box.price ul li {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.content .box.price ul li .border-between {
  display: block;
  border-top: 1px dashed #cbd4e1;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -moz-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0 10px;
  margin-top: 2px;
}

.content .box.price ul li:not(:first-of-type) {
  margin-top: 10px;
}

.content .box.price ul li:last-of-type {
  margin-top: 0;
}

.content .box.price ul li:last-of-type span:first-of-type {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.content .box.price ul li:last-of-type span:last-of-type {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .box.price ul li:not(:last-of-type) span:first-of-type {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .box.price ul li:not(:last-of-type) span:last-of-type {
  font-size: 12px;
  line-height: 18px;
  color: #000000;
}

.content .buttons {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 20px 0;
}

.content .buttons button,
.content .buttons a {
  padding: 0.6rem 1.1rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  border: none;
}

.content .buttons > button {
  background: #fb4b4b;
  color: #f6f8fc;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .buttons > button:hover {
  background-color: #de4343;
  color: #fff;
}

.content .buttons .right a {
  border: 1px solid #64748b;
  color: #64748b;
  background: #f6f8fc;
  text-decoration: none;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .buttons .right a:hover {
  color: #4b5768;
  border-color: #4b5768;
  background-color: #eaf0fa;
}

.content .buttons .right button {
  background: #5855d6;
  color: #f6f8fc;
  margin-left: 10px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .buttons .right button:hover {
  background-color: #4947b0;
  color: #fff;
}

.period_end_desc {
  background: #f0eff5;
  height: 34px;
  width: 150px;
  border-radius: 2px;
  position: relative;
  box-shadow: 0px 1px 1px rgb(9 30 66 / 25%), 0px 0px 1px rgb(9 30 66 / 31%);
}

.period_end_desc > span {
  position: absolute;
  top: 10px;
  left: 27px;
}

.input-select {
  background: #f0eff5;
  box-shadow: 0px 1px 1px rgb(9 30 66 / 25%), 0px 0px 1px rgb(9 30 66 / 31%);
  border-radius: 4px;
  border: none;
  text-indent: 5px;
}

.col-form {
  background: #e6e5eb;
  box-shadow: 0px 1px 1px rgb(9 30 66 / 25%), 0px 0px 1px rgb(9 30 66 / 31%);
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  height: 22px;
  border: none;
  display: block;
  padding: 1px 5px;
  margin: 0 auto;
  text-align: center;
  width: 100px !important;
}

.mid-2 {
  width: 100px;
}

.amount-dropdown {
  max-height: 300px;
  overflow-y: auto;

  li {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f5f7fa;
    }

    &:last-child {
      border-bottom: none !important;
    }

    div {
      line-height: 1.4;
    }
  }
}

.inputFields {
  background: #f0eff5;
  box-shadow: 0px 1px 1px rgb(9 30 66 / 25%), 0px 0px 1px rgb(9 30 66 / 31%);
  border-radius: 4px;
  border: none;
  width: 100%;
  height: 30px;

  &:focus-visible {
    border: none;
  }
}

.datePicker {
  & .dp__input_icon_pad {
    width: 100% !important;
  }
}

.form select {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  height: 42px;
  width: 150px;
  border: none;
  text-indent: 5px;
}

.form select.big {
  width: 192px;
}

.form .radio {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background: #333269;
  border-radius: 4px;
  color: #d2d1d7;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
}

.formc .radio input {
  display: none;
}

.form.radio input:checked + label {
  background: #f6f8fc;
  color: #000000;
}

.form .radio label {
  margin: 0;
  cursor: pointer;
  padding: 1px 11.5px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  border-radius: 4px;
}

.form .radio label:first-of-type {
  margin-right: 10px;
}

.form button {
  background: #5855d6;
  width: 126px;
  height: 38px;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  border: none;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 3%;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.form button:hover {
  background-color: #4947b0;
  color: #fff;
}

.form textarea {
  background: #f0eff5;
  border-radius: 5px;
  height: 78px;
  resize: none;
  width: 214px;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  border: none;
  padding: 10px;
}

.form textarea:focus {
  border: none;
  outline: none;
}

.form .inputFields {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
    0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  border: none;
  height: 42px;
  width: 95px;
  text-indent: 10px;
  padding-right: 5px;
}

.form .inputFields.big {
  width: 192px;
}

.form .inputFields:-moz-read-only {
  background: #f0eff5;
}

.form .inputFields:read-only {
  background: #f0eff5;
}

.form .inputFields:focus {
  outline: none;
}

.form .inputFields.input[type="date"] {
  text-indent: 5px;
}

.form .inputFields.input[type="date"]::-webkit-clear-button,
.form .inputFields.input[type="date"]::-webkit-inner-spin-button,
.form .inputFields.input[type="date"]::-webkit-calendar-picker-indicator,
.form .inputFields.input[type="date"]::-webkit-outer-spin-button {
  display: none;
  -webkit-appearance: none;
  appearance: none;
}

.form .inputFields.input[type="number"] {
  width: 55px;
  -webkit-appearance: textfield;
  appearance: textfield;
  -moz-appearance: textfield;
}

.form .inputFields.input[type="number"]::-webkit-outer-spin-button,
.form .inputFields.input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.outline-purple {
  background: #fff !important;
  color: #5855d6 !important;
  border: 1px solid #5855d6 !important;
}
.description {
  min-width: 220px; /* Adjust as needed to make it the longest */
}
</style>
